import Command from '../../actions/command';
import {call, fork, put, take} from 'redux-saga/effects';
import {Action} from 'redux-actions';
import Event from '../../actions/event';
import Api from '../../../api';
import {FetchYearlyRevenuePayload} from '../../actions/dashboardCommand';

function* onFetchYearlyRevenue(data: FetchYearlyRevenuePayload): Generator {
    try {
        const yearlyData: any = yield call(Api.Query.yearlyRevenue, data.year);
        yield put(Event.Dashboard.yearlyRevenueFetched({ data: yearlyData }));
    } catch (e) {
        yield put(Command.Notification.enqueueNotification({
            severity: 'error',
            message: 'Jahresdaten konnten nicht geladen werden.',
        }));
    }
}

export function* fetchYearlyRevenueFlow() {
    while (true) {
        const action: Action<FetchYearlyRevenuePayload> =
            yield take(Command.Dashboard.fetchYearlyRevenue.toString());
        yield fork(onFetchYearlyRevenue, action.payload);
    }
}
